import httpClient from './httpClient';

export const fetchLessons = async (studentId) => {
  const { data } = await httpClient.get(`/lessons/${studentId}`);
  return data;
};

export const createLesson = async (payload) => {
  const { data } = await httpClient.post('/lessons', payload);
  return data;
};

export const updateLesson = async (id, payload) => {
  const { data } = await httpClient.put(`/lessons/${id}`, payload);
  return data;
};

export const deleteLesson = async (id) => {
  await httpClient.delete(`/lessons/${id}`);
};

export const uploadHomeworkFile = async (lessonId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  // Content-Type не виставляємо вручну — axios сам додає multipart boundary
  const { data } = await httpClient.post(`/lessons/${lessonId}/homework-files`, formData);
  return data;
};

export const downloadHomeworkFile = async (lessonId, fileId) => {
  const { data } = await httpClient.get(`/lessons/${lessonId}/homework-files/${fileId}`, {
    responseType: 'blob',
  });
  return data;
};

export const deleteHomeworkFile = async (lessonId, fileId) => {
  await httpClient.delete(`/lessons/${lessonId}/homework-files/${fileId}`);
};



